// ── Checklist Tab ────────────────────────────────────────────────────────────
import { getTrip }       from '@/store/tripState';
import { CHECK_CATS }   from '@/constants';
const CATS = CHECK_CATS;
import { saveTrip }      from '@/services/sync.service';
import { toArr, sanitize } from '@/helpers';
import type { CheckItem, CheckCat } from '@/types';



export function renderChecklist(): void {
  const el  = document.getElementById('checklist-items');
  const cnt = document.getElementById('check-count');
  if (!el) return;
  const arr  = toArr(getTrip().checks ?? {}) as CheckItem[];
  const done = arr.filter(c => c.done).length;
  if (cnt) cnt.textContent = `${done}/${arr.length}`;
  if (!arr.length) { el.innerHTML = '<div class="empty">Nenhum item no checklist.</div>'; return; }

  const byCat: Record<string, CheckItem[]> = {};
  CATS.forEach(c => { byCat[c] = []; });
  arr.forEach(c => { (byCat[c.cat] ?? (byCat['Outros'] = byCat['Outros'] ?? [])).push(c); });

  el.innerHTML = CATS.filter(c => byCat[c]?.length).map(cat => `
    <div style="font-size:11px;font-weight:600;color:var(--muted);text-transform:uppercase;letter-spacing:.05em;padding:8px 0 4px;margin-top:4px">${cat}</div>
    ${byCat[cat].map(c => `
      <div class="check-item">
        <input type="checkbox" id="chk-${c.id}" ${c.done ? 'checked' : ''} onchange="window.__toggleCheck('${c.id}')">
        <label for="chk-${c.id}" class="${c.done ? 'done' : ''}">${sanitize(c.texto)}</label>
        <button class="icon-btn del" onclick="window.__delItem('checks','${c.id}')">×</button>
      </div>`).join('')}
  `).join('');
}

export function toggleCheck(id: string): void {
  const c = getTrip().checks?.[id];
  if (c) saveTrip(`checks/${id}/done`, !c.done).catch(() => void 0);
}
